import TimeCounter from "@/components/AgentActions/TimeCounter";

// @vue/component
export default {
  name: "Action",

  components: {
    TimeCounter
  },

  props: {
    status: {
      type: Boolean,
      default: false
    },
    typeOn: {
      type: String,
      default: "success"
    },
    typeOff: {
      type: String,
      default: "danger"
    },
    typeDisable: {
      type: String,
      default: "info"
    },
    textOn: {
      type: String,
      default: "Wyłącz"
    },
    textOff: {
      type: String,
      default: "Włącz"
    },
    actionId: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isPopconfirm: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTimerFinished: false
    };
  },
  computed: {},
  created() {},
  methods: {
    changeStatus() {
      if (Number(this.actionId) === Number(3) && this.status) {
        this.$refs.timeCounter.stopCounting();
        this.$emit("changeStatus", { status: this.status, actionId: this.actionId });
      } else if (Number(this.actionId) === Number(1) && this.status) {
        this.$confirm(
          "To działanie spowoduje wylogowanie ze wszystkich infolinii. Czy chcesz kontynuować?",
          "Ostrzeżenie",
          {
            confirmButtonText: "Wyloguj",
            cancelButtonText: "Anuluj",
            type: "warning"
          }
        )
          .then(() => this.$emit("changeStatus", { status: this.status, actionId: this.actionId }))
          .catch(() => {
            this.$message({
              showClose: true,
              type: "info",
              message: "Wylogowanie z infolinii zostało anulowane"
            });
          });
      } else {
        this.$emit("changeStatus", { status: this.status, actionId: this.actionId });
      }
    }
  }
};
